// 駐車場
const ModalBuildingEditorParking = {
  namespaced: true,

  state: {
    modal: false,
    item: {},
  },
  getters: {
    getModal: state => {
      return state.modal
    },
    getItem: state => {
      return state.item
    },
  },
  mutations: {
    setModal(state, modal) {
      state.modal = modal
    },
    setItem(state, item) {
      state.item = item
    },
  },
  actions: {},
}

export default ModalBuildingEditorParking
